/* ViaDünya native interactions — no external libraries or tracking. */
document.addEventListener('DOMContentLoaded', () => {
  const formatMoney = (cents) => {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 2 }).format(value);
    } catch (e) {
      return `${value.toFixed(2)} TL`;
    }
  };

  document.querySelectorAll('[data-auto-submit]').forEach(select => {
    select.addEventListener('change', () => select.closest('form')?.requestSubmit());
  });

  const updateHeaderCartCount = (delta = 1) => {
    const cartIcon = document.querySelector('.cart-icon');
    if (!cartIcon) return;
    let badge = cartIcon.querySelector('.cart-count');
    const current = Number(badge?.textContent || 0);
    const next = current + delta;
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'cart-count';
      cartIcon.appendChild(badge);
    }
    badge.textContent = String(next);
    cartIcon.setAttribute('aria-label', `Sepet, ${next} ürün`);
  };

  document.querySelectorAll('[data-product-root]').forEach(root => {
    const input = root.querySelector('input[name="quantity"]');
    root.querySelector('[data-qty-decrease]')?.addEventListener('click', () => {
      if (input) input.value = String(Math.max(1, (parseInt(input.value, 10) || 1) - 1));
    });
    root.querySelector('[data-qty-increase]')?.addEventListener('click', () => {
      if (input) input.value = String((parseInt(input.value, 10) || 0) + 1);
    });
    const variants = root.querySelector('[data-variant-select]');
    const cards = Array.from(root.querySelectorAll('[data-variant-card]'));
    const syncFromOption = (option) => {
      if (!option) return;
      const price = root.querySelector('[data-current-price]');
      if (price) {
        price.textContent = option.dataset.price || '';
        if (option.dataset.compare) {
          const old = document.createElement('s');
          old.textContent = option.dataset.compare;
          price.append(' ', old);
        }
      }
      const button = root.querySelector('[data-atc]');
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.innerHTML = button.disabled ? 'Tükendi' : 'Sepete ekle <span aria-hidden="true">↗</span>';
      }
      cards.forEach(card => {
        const active = String(card.dataset.variantId) === String(option.value);
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const chosenColor = option.dataset.option;
      const gallery = root.querySelector('[data-local-gallery]');
      if (gallery && chosenColor) {
        const matchingImage = Array.from(gallery.querySelectorAll('[data-local-color]')).find(el => el.dataset.localColor === chosenColor);
        if (matchingImage) gallery.scrollTo({ left: matchingImage.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      }
      const featuredMediaId = option.dataset.mediaId;
      if (featuredMediaId) {
        const mediaFigure = root.querySelector('#media-' + featuredMediaId);
        const mediaStrip = root.querySelector('.gallery-primary');
        if (mediaFigure && mediaStrip) mediaStrip.scrollTo({ left: mediaFigure.offsetLeft - mediaStrip.offsetLeft, behavior: 'smooth' });
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState(null, '', url.toString());
    };

    variants?.addEventListener('change', () => syncFromOption(variants.selectedOptions[0]));
    cards.forEach(card => {
      card.addEventListener('click', () => {
        if (!variants) return;
        const targetOption = Array.from(variants.options).find(option => String(option.value) === String(card.dataset.variantId));
        if (!targetOption) return;
        variants.value = targetOption.value;
        variants.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (variants) syncFromOption(variants.selectedOptions[0]);
  });

  const modal = document.querySelector('[data-quick-add-modal]');
  if (modal) {
    const optionsWrap = modal.querySelector('[data-quick-add-options]');
    const submit = modal.querySelector('[data-quick-add-submit]');
    const price = modal.querySelector('[data-quick-add-price]');
    const title = modal.querySelector('#QuickAddTitle');
    const copy = modal.querySelector('[data-quick-add-copy]');
    let selectedVariant = null;

    const closeModal = () => {
      modal.hidden = true;
      document.body.classList.remove('modal-open');
      optionsWrap.innerHTML = '';
      submit.disabled = true;
      price.textContent = 'Seçim yapın';
      selectedVariant = null;
    };

    const openModal = (card) => {
      const jsonNode = card.querySelector('[data-quick-add-variants]');
      if (!jsonNode) return;
      const variants = JSON.parse(jsonNode.textContent || '[]');
      const productTitle = card.dataset.productTitle || 'Ürün';
      const optionName = card.dataset.productOptionName || 'Seçenek';
      title.textContent = `${productTitle} için ${optionName.toLowerCase()} seçin`;
      copy.textContent = 'Sepete eklemeden önce size uygun seçeneği işaretleyin.';
      optionsWrap.innerHTML = '';
      variants.forEach(variant => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'variant-card';
        btn.dataset.variantId = variant.id;
        btn.disabled = !variant.available;
        btn.innerHTML = `<span class="variant-card__title">${variant.option1 || variant.title}</span><span class="variant-card__price">${formatMoney(variant.price)}</span>${variant.compare_at_price && variant.compare_at_price > variant.price ? `<s>${formatMoney(variant.compare_at_price)}</s>` : ''}${!variant.available ? '<span class="variant-card__meta">Tükendi</span>' : ''}`;
        btn.addEventListener('click', () => {
          optionsWrap.querySelectorAll('.variant-card').forEach(el => {
            el.classList.remove('is-active');
            el.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
          selectedVariant = variant;
          price.innerHTML = `${formatMoney(variant.price)}${variant.compare_at_price && variant.compare_at_price > variant.price ? ` <s>${formatMoney(variant.compare_at_price)}</s>` : ''}`;
          submit.disabled = false;
        });
        optionsWrap.appendChild(btn);
      });
      modal.hidden = false;
      document.body.classList.add('modal-open');
    };

    document.querySelectorAll('[data-quick-add-trigger]').forEach(button => {
      button.addEventListener('click', () => openModal(button.closest('[data-product-card]')));
    });
    modal.querySelectorAll('[data-quick-add-close]').forEach(button => button.addEventListener('click', closeModal));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });
    submit.addEventListener('click', async () => {
      if (!selectedVariant) return;
      submit.disabled = true;
      submit.textContent = 'Ekleniyor…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(selectedVariant.id), quantity: 1 }] })
        });
        if (!response.ok) throw new Error('add_failed');
        updateHeaderCartCount(1);
        closeModal();
      } catch (error) {
        price.textContent = 'Eklenemedi. Tekrar deneyin.';
      } finally {
        submit.innerHTML = 'Sepete ekle <span aria-hidden="true">↗</span>';
      }
    });
  }
});
